export default __webpack_public_path__ + "static/media/virtualpad_bt_a.d6bdc00e.png";